(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloFunzioneDetailController', RuoloFunzioneDetailController);

    RuoloFunzioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RuoloFunzione', 'Operazione', 'Ruolo', 'Funzione'];

    function RuoloFunzioneDetailController($scope, $rootScope, $stateParams, previousState, entity, RuoloFunzione, Operazione, Ruolo, Funzione) {
        var vm = this;

        vm.ruoloFunzione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:ruoloFunzioneUpdate', function(event, result) {
            vm.ruoloFunzione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
